import Cookies from "js-cookie";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

export const REQUESTED_LOCATION_COOKIE = "_target";

const IGNORED_PATHS = [
    MarketplaceRoutes.LOGIN,
    MarketplaceRoutes.LOGOUT,
    MarketplaceRoutes.SIGNIN,
    MarketplaceRoutes.SIGNUP,
    MarketplaceRoutes.STRIPE_SIGNUP,
    MarketplaceRoutes.COMPLETE_PROFILE,
    MarketplaceRoutes.VALIDATE_ACCOUNT,
    MarketplaceRoutes.INVITATION,
    MarketplaceRoutes.RETAILER_STRIPE_CONFIRM,
    MarketplaceRoutes.ERROR,
    MarketplaceRoutes.NOT_FOUND,
];

export function getCurrentSubdomain() {
    const hostname = window.location.hostname;
    const suffix = "." + process.env.REACT_APP_HOST;

    return hostname.endsWith(suffix) ? hostname.slice(0, -suffix.length) : null;
}

export function saveRequestedLocation() {
    const subdomain = getCurrentSubdomain();
    const pathname = window.location.pathname;
    const authSubdomain = process.env.REACT_APP_CUSTOM_AUTH_SUBDOMAIN ?? "auth.";

    if (
        !subdomain ||
        subdomain + "." === authSubdomain ||
        pathname === MarketplaceRoutes.ROOT ||
        IGNORED_PATHS.some((ignoredPath) => pathname.startsWith(ignoredPath))
    ) {
        return;
    }

    Cookies.set(
        REQUESTED_LOCATION_COOKIE,
        JSON.stringify({subdomain, path: pathname + window.location.search}),
        {domain: process.env.REACT_APP_HOST, expires: 0.01, secure: true}
    );
}

export function getRequestedLocation() {
    const stored = Cookies.get(REQUESTED_LOCATION_COOKIE);

    if (!stored) {
        return null;
    }

    try {
        const requested = JSON.parse(stored);

        if (
            typeof requested.subdomain !== "string" ||
            typeof requested.path !== "string" ||
            !requested.path.startsWith("/") ||
            requested.path.startsWith("//")
        ) {
            clearRequestedLocation();
            return null;
        }

        return requested;
    } catch (e) {
        clearRequestedLocation();
        return null;
    }
}

export function clearRequestedLocation() {
    Cookies.remove(REQUESTED_LOCATION_COOKIE, {domain: process.env.REACT_APP_HOST});
}
